import React from 'react';
import moment from 'moment';

import { Link } from '../../components';

const StaticFooter = () => (
  <footer className="footer section u-contrast u-textCenter">
    <div className="container">
      <p>
        <strong>&copy; {moment().format('Y')} Gremlin Inc.</strong>
        <br />
        All rights reserved.
        <br />
        <Link className="u-link u-textUnderline" to="/privacy/">
          Privacy Policy
        </Link>
      </p>
    </div>
  </footer>
);

export default StaticFooter;
